import React from 'react';
import TranslatedTextComponent from "./TranslatedTextComponent";
import gift from "../img/gift_no_patch.png";

const TitleZoneComponent = ({title, showProgramTitle, showIcon}) => {
    return (
        <div className="title-zone">
            <div className="title">
                {showProgramTitle && <TranslatedTextComponent textKey="title" className="program-title-overview"/>}
                {showIcon && <img src={gift} alt="" className="title-icon"/>}{title}
            </div>
        </div>
    );
};

export default TitleZoneComponent;